import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const LoginPage = lazy(() => import('./pages/LoginPage'))
const ForgotPasswordPage = lazy(() => import('./pages/ForgotPasswordPage'))

export const authRoutes: RouteObject[] = [
  {
    path: '/auth/login',
    element: <LoginPage />,
  },
  {
    path: '/auth/forgot-password',
    element: <ForgotPasswordPage />,
  },
  // Future routes:
  // { path: '/auth/reset-password', element: <ResetPasswordPage /> },
  // { path: '/auth/2fa', element: <TwoFactorPage /> },
  // { path: '/auth/select-company', element: <CompanySelectPage /> },
]
